// Mismo criterio que cajaChica/permisos.js y cajaInstalacion/permisos.js.
export const esSubRolContable = (subRol) => String(subRol || "").toLowerCase().startsWith("cont");

export const esRolAdminGerenteContable = (user) =>
  user?.role === "admin" || user?.role === "gerente" || esSubRolContable(user?.sub_rol);
